import _visuallyHidden from './visuallyHidden.module.css';

/**
 * Class name to visually hide an element while keeping it in the accessibility
 * tree.
 *
 * @example
 *
 * ```tsx
 * import { visuallyHidden } from 'corgi-x/styles';
 * function Example() {
 *  <div className={visuallyHidden}>Hidden text</div>
 * }
 * ```
 */
export const visuallyHidden = _visuallyHidden.visuallyHidden;
